import { FeatureFlag } from '@revelio/core';

export const allFlags = () => {
  return Object.values(FeatureFlag);
};
